//import {getLabel} from '../API';
export default function createConstraints(fields,context){
  if(!fields) return {};
  const constraints={};
  fields.forEach((field) => {
    if(field.required && (!field.not_input || field.not_input!=="true") && field.type!=="Action" && field.type!=="Link" && field.type!=="Group" && field.type!=="Array" ){
      if(field.type=="Number" && !field.ref_model){
        constraints[field.name] = {
          numericality: {
            //onlyInteger: true,
            greaterThan: 0,
            message: '^' + context.apis.getLabel(field.header||"").toLowerCase(),
            //lessThanOrEqualTo: 30,
            //even: true,
            //notEven: "must be evenly divisible by two"
            //notValid
            //notInteger
            //notGreaterThan
            //notGreaterThanOrEqualTo
            //notEqualTo
            //notLessThan
            //notLessThanOrEqualTo
            //notDivisibleBy
            //notOdd
          }
        }
      }else{
        constraints[field.name] = {
          presence: {allowEmpty: false,message: '^' + context.apis.getLabel(field.header||"").toLowerCase()}
        }
      }
      
    }
  });
  return constraints;
}